import React from 'react';
import { _ as _taggedTemplateLiteralLoose } from '../../../dist/taggedTemplateLiteralLoose-8a80a17d.esm.js';
import { textSizes } from '@growth/design-system';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Checkbox$1 = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: max-content;\n\n\t> b {\n\t\tposition: relative;\n\t\tmargin-left: auto;\n\t\tcursor: pointer;\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tborder-radius: 4px;\n\t\tbackground-color: white;\n\t\tborder: 2px solid #9b9b9b;\n\t}\n"])));
var CheckboxInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\n\t& + b {\n\t\tborder: 2px solid ", ";\n\t}\n\n\t/* CHECKED STATE */\n\t&:checked + b::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tdisplay: flex;\n\t\tflex-shrink: 0;\n\t\ttop: -2px;\n\t\tleft: -2px;\n\t\tborder-radius: 4px;\n\t\tbackground-color: #2276e3;\n\t}\n\n\t&:checked + b::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 40%;\n\t\tleft: 50%;\n\t\theight: 5px;\n\t\twidth: 10px;\n\t\tborder-bottom: 1.5px solid #ffffff;\n\t\tborder-left: 1.5px solid #ffffff;\n\t\ttransform-origin: center;\n\t\ttransform: translate(-50%, -50%) rotate(-45deg);\n\t}\n"])), function (props) {
  return props.isError ? '#FF1515' : '#9b9b9b';
});
var CheckboxWithLabel = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n"])));
var CheckboxLabel = styled.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\t", "\n\tcolor: #4a4a4a;\n\t", ";\n\n\t/* ERROR STATE */\n\t", ";\n"])), textSizes.SmallW1, function (props) {
  return props.extraCss ? props.extraCss : null;
}, function (props) {
  return props.isError && "\n    color: #960D11;\n  ";
});
var Styled = {
  Checkbox: Checkbox$1,
  CheckboxInput: CheckboxInput,
  CheckboxWithLabel: CheckboxWithLabel,
  CheckboxLabel: CheckboxLabel
};

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      id = _ref.id,
      isChecked = _ref.isChecked,
      isError = _ref.isError,
      checkboxName = _ref.checkboxName,
      checkboxHandler = _ref.checkboxHandler,
      extraCss = _ref.extraCss;
  return label ? /*#__PURE__*/React.createElement(Styled.CheckboxWithLabel, null, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return checkboxHandler(id, checkboxName);
    },
    onKeyDown: function onKeyDown() {
      return checkboxHandler(id, checkboxName);
    }
  }, /*#__PURE__*/React.createElement(Styled.Checkbox, null, /*#__PURE__*/React.createElement(Styled.CheckboxInput, {
    id: id,
    type: "checkbox",
    name: checkboxName,
    isError: !isChecked && isError,
    checked: isChecked,
    onChange: function onChange() {
      return checkboxHandler(id, checkboxName);
    }
  }), /*#__PURE__*/React.createElement("b", null, "\xA0"))), /*#__PURE__*/React.createElement(Styled.CheckboxLabel, {
    extraCss: extraCss,
    isError: !isChecked && isError,
    htmlFor: id
  }, label)) : /*#__PURE__*/React.createElement(Styled.Checkbox, {
    onClick: function onClick() {
      return checkboxHandler(id, checkboxName);
    }
  }, /*#__PURE__*/React.createElement(Styled.CheckboxInput, {
    id: id,
    type: "checkbox",
    name: checkboxName,
    checked: isChecked,
    isError: !isChecked && isError,
    onChange: function onChange() {}
  }), /*#__PURE__*/React.createElement("b", null, "\xA0"));
};

export { Checkbox as default };
